<template>
	<div class="border-b border-zt-light border-x rounded-zt">
		<template v-if="Object.keys(rounds).length > 0" v-for="(value, key, index) in roundsToShow">
			<template v-for="(match, mIndex) in value.round_matches">
				<FootballStatsListItem :match="match" class="footballStatsListItem"
				                       :class="{ 'rounded-b-zt border-b-0' : noOfRounds - 1 === index && value.round_matches.length - 1 === mIndex,
				                       'rounded-t-zt' : index === 0 && mIndex === 0}"
				                       show-date show-hour show-odds
                               :show-teams-bg="showTeamsBgs"
                               :redirect-to-h2h="match.is_h2h_available"/>
			</template>
		</template>
		<p v-else class="text-xs rounded-b-zt border-zt-light text-zt-more text-center font-normal w-full -leading-[0.18px] bg-zt-light-full py-2.5">
			Brak meczów do wyświetlania
		</p>
		<div v-if="noOfRounds > this.amount" class="py-4 flex items-center bg-zt-light/35 border-zt-light justify-center text-zt-more text-xs underline font-normal uppercase">
			<span class="cursor-pointer zt-hover" @click="amount += 10">Rozwiń</span>
		</div>
	</div>
</template>

<script>
import FootballStatsListItem from '../../blocks/FootballStatsListItem.vue';

export default {
	name: 'TeamTimetable',
	components: {FootballStatsListItem},
	inject: ['WP'],
  props: {
    teamId: {
      type: Number,
      required: true
    },
		rounds: {
      type: Object,
      required: true
    },
		leagueName: {
			type: String,
		},
		countryName: {
			type: String,
		},
    countryPolishQueryName: {
			type: String,
		},
    showTeamsBgs: {
      type: Array,
      default: []
    },
  },
	data() {
		return {
			amount: 5,
		}
	},
	computed: {
		roundsToShow() {
			return Object.fromEntries(
				Object.entries(this.rounds).slice(0, this.amount)
			);
		},
		noOfRounds() {
			return Object.keys(this.rounds).length
		},
		countryFlag() {
			return `/wp-content/themes/zawodtyper/assets/images/kraje/${this.countryPolishQueryName.toLowerCase()}.svg`;
		}
	}
}
</script>

<style scoped>
	.footballStatsListItem {
		@apply border-x-0 border-t-0;
	}

	.footballStatsListItem:first-of-type {
		@apply !border-t;
	}
</style>